import {getChartConfiguration} from "./chart-configuration";
import {views} from "./helpers/views";
import {colors} from "./colors";

const getStandbyUsageChartConfiguration = (date, view, lang, type, fullscreen, debug = false, environment = "apps", timezone) => {
    let chartConfiguration = getChartConfiguration(date, view, lang, type, fullscreen, debug, environment, false, timezone)

    // background
    chartConfiguration.data.datasets[0] = {
        ...chartConfiguration.data.datasets[0],
        order: 2,
        borderWidth: 0,
        fill: 'origin',
    }

    // standby
    chartConfiguration.data.datasets[1] = {
        ...chartConfiguration.data.datasets[1],
        order: 1,
        borderWidth: views[view] <= views.day ? 2 : 1,
        fill: 'origin'
    }

    if (views[view] > views.day) {
        chartConfiguration.options.scales.xAxes[0].stacked = true
        chartConfiguration.options.scales.yAxes[0].stacked = true
    }

    chartConfiguration.plugins[0].beforeLayout = (chart, options) => {
        // Make sure the standby line is visible, by cutting of extreme data spikes, if any
        if (chart.data.datasets[0].max && views[view] <= views.day) {
            let dataMax = chart.data.datasets[0].max
            let standbyMax = chart.data.datasets[1].max

            let suggestedMax = Math.ceil(Math.min(dataMax, 5 * standbyMax)/100)*100
            console.debug('suggestedMax', suggestedMax)
            chart.options.scales.yAxes[0].ticks.max = suggestedMax
        }
        chart.options.scales.yAxes[0].ticks.min = 0
    }

    chartConfiguration.plugins[0].afterLayout = (chart, options) => {
        // Calculate the right gradient for graphs based on rendered data
        let yScale = chart.scales['y-axis-0']
        let bgGradient, borderGradient

        // power
        bgGradient = [
            [
                colors.power_import_standby.gradient_end,
                colors.power_import_standby.gradient_start,
                colors.power_export_standby.gradient_end,
                colors.power_export_standby.gradient_start,
            ], [
                view === 'day' ? colors.power_export.gradient_start : colors.power_export.gradient_end,
                view === 'day' ? colors.power_export.gradient_end : colors.power_export.gradient_start
            ]
        ]

        borderGradient = [
            [colors.power_import.border, colors.power_export.border],
            [colors.power_export.border,colors.power_import.border]
        ]

        chart.data.datasets.forEach((dataset, index) => {
            console.debug(`dataset number: ${index}`)
            if (dataset.data.length === 0) {
                return
            }

            let gradient = chart.ctx.createLinearGradient(0, 0, 0, chart.height)
            let {min, max} = dataset

            const getColorStop = (val) =>
                Math.max(0, Math.min(yScale.getPixelForValue(val || 0) / chart.height, 1))

            if (index === 0) {
                // background dataset
                if (min < 0 && max > 0) {
                    // a dataset with positive and negative values should use a double gradient
                    gradient.addColorStop(getColorStop(max), bgGradient[index][1]) // import
                    gradient.addColorStop(getColorStop(0), bgGradient[index][0]) // import
                    gradient.addColorStop(getColorStop(0), bgGradient[index][2]) // export
                    gradient.addColorStop(getColorStop(min), bgGradient[index][3]) // export

                    let bg = chart.ctx.createLinearGradient(0, 0, 0, chart.height)
                    bg.addColorStop(getColorStop(0), borderGradient[index][0]) // import
                    bg.addColorStop(getColorStop(0), borderGradient[index][1]) // export
                } else {
                    gradient.addColorStop(getColorStop(min), bgGradient[index][min < 0 ? 3 : 0])
                    gradient.addColorStop(getColorStop(max), bgGradient[index][min < 0 ? 2 : 1])
                }
            }

            if (index === 1) {
                // standby dataset
                gradient.addColorStop(getColorStop(min), colors.power_import.gradient_end)
                gradient.addColorStop(getColorStop(max), colors.power_import.gradient_start)
                dataset.borderColor = borderGradient[0][0]
            }

            dataset.backgroundColor = gradient
        })
    }

    return chartConfiguration
}

export {getStandbyUsageChartConfiguration}
